import { render, staticRenderFns } from "./AdministrationOrders.vue?vue&type=template&id=3d834ba4&scoped=true&"
import script from "./AdministrationOrders.vue?vue&type=script&lang=js&"
export * from "./AdministrationOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d834ba4",
  null
  
)

export default component.exports